import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { RATE_LIMIT_ERROR_CODES } from "../constants/errorCodes";

export interface RateLimitErrorOptions {
  message: string;
  limit?: number;
  remaining?: number;
  resetTime?: Date;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown when rate limits are exceeded
 */
export class RateLimitError extends BaseError {
  public readonly limit?: number;
  public readonly remaining?: number;
  public readonly resetTime?: Date;

  constructor(options: RateLimitErrorOptions) {
    super({
      message: options.message,
      category: "rate_limit",
      severity: "medium",
      statusCode: 429,
      code: options.code ?? RATE_LIMIT_ERROR_CODES.RATE_LIMIT_EXCEEDED,
      context: options.context,
      cause: options.cause,
      userVisible: true,
      reportable: false,
    });

    this.limit = options.limit;
    this.remaining = options.remaining;
    this.resetTime = options.resetTime;
  }
}
